import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Drivers from './pages/Drivers';
import Trucks from './pages/Trucks';
import Reports from './pages/Reports';
import ProfitLoss from './pages/ProfitLoss';
import UnifiedActions from './pages/UnifiedActions';
import UserManagementBasic from './pages/UserManagementBasic';
import AuditTrail from './pages/AuditTrail';
import Pricing from './pages/Pricing';

function App() {
  const authConfig = {
    signUpAttributes: ['email', 'given_name', 'family_name'],
    loginMechanisms: ['email'],
    socialProviders: [],
  };

  return (
    <Authenticator 
      signUpAttributes={authConfig.signUpAttributes}
      loginMechanisms={authConfig.loginMechanisms}
      socialProviders={authConfig.socialProviders}
      hideSignUp={true}
      components={{
        Header() {
          return (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <img 
                src="/logo.png" 
                alt="DAN-CHI LOGISTICS" 
                style={{ height: '80px', marginBottom: '20px' }}
              />
            </div>
          );
        }
      }}
    >
      {({ signOut, user }) => {
        // Check user type and permissions
        const userType = user?.attributes?.['custom:user_type'];
        
        // Allow admin and owner users
        if (userType !== 'admin' && userType !== 'owner') {
          return (
            <div style={{ padding: '20px', textAlign: 'center' }}>
              <h2>Access Denied</h2>
              <p>This portal is for administrators and owners only.</p>
              <p>User type: {userType || 'Unknown'}</p>
              <button onClick={signOut}>Sign Out</button>
            </div>
          );
        }

        return (
          <Router>
            <Layout user={user} signOut={signOut}>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/drivers" element={<Drivers />} />
                <Route path="/trucks" element={<Trucks />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/audit-trail" element={<AuditTrail />} />
                <Route path="/profit-loss" element={<ProfitLoss />} />
                {(userType === 'admin' || userType === 'owner') && <Route path="/unified-actions" element={<UnifiedActions />} />}
                {(userType === 'admin' || userType === 'owner') && <Route path="/pricing" element={<Pricing />} />}
                {userType === 'admin' && <Route path="/users" element={<UserManagementBasic />} />}
              </Routes>
            </Layout>
          </Router>
        );
      }}
    </Authenticator>
  );
}

export default App;